import React from 'react';

function PageUnderConstruction() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 text-center">
      <div className="p-8 bg-white rounded-lg shadow-lg max-w-lg">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Page Under Construction</h1>
        <p className="text-lg text-gray-600">
          Sorry, the page you're looking for doesn't exist or is under construction.
        </p>
      </div>
    </div>
  );
}

export default PageUnderConstruction;
